const subscribersMap = {};
const addedGlobalEventListeners = false;

/**
 * Returns an element
 * @param {*} elementSelector
 */
const getElement = elementSelector => {
  return document.querySelector(elementSelector);
};

/**
 * Iterate through the listeners list and try to resolve
 * the promise if they are visible in the viewport
 * TODO: Fix the viewport detection part
 */
const resolveListeners = () => {
  const subscribersKeyList = Object.keys(subscribersMap);
  if (subscribersKeyList.length > 0) {
    for (let index = 0; index < subscribersKeyList.length; index++) {
      const key = subscribersKeyList[index];
      if (subscribersMap[key]) {
        //Only full load component when is visible in viewport
        if (isElementInViewport(getElement(key))) {
          subscribersMap[key].resolve(true);
          subscribersMap[key] = null;
          delete subscribersMap[key];
        }
      }
    }
  }
};

/**
 * Helper function to simulate a setInterval but
 * wthout hurting the browser performance
 * @param {*} fn
 * @param {*} delay
 */
const requestInterval = (fn, delay) => {
  const requestAnimFrame = (() => {
    return (
      window.requestAnimationFrame ||
      function hello(callback) {
        window.setTimeout(callback, 1000 / 60);
      }
    );
  })();
  let start = new Date().getTime();
  const handle = {};
  function loop() {
    handle.value = requestAnimFrame(loop);
    const current = new Date().getTime();
    const delta = current - start;
    if (delta >= delay) {
      fn.call();
      start = new Date().getTime();
    }
  }
  handle.value = requestAnimFrame(loop);
  return handle;
};

/**
 * Try to resolve all listeners once an
 * user wants to play with the components
 * this heuristics are very basic, we should
 * find better ones.
 */
const addGlobalEventListeners = () => {
  window.addEventListener("scroll", () => {
    resolveListeners();
  });

  window.addEventListener("click", () => {
    resolveListeners();
  });

  window.addEventListener("mousemove", () => {
    resolveListeners();
  });

  window.addEventListener("keydown", () => {
    resolveListeners();
  });

  requestInterval(() => {
    resolveListeners();
  }, 2000);
};

/**
 * Returns the DocElement
 */
const getDocElement = () => {
  if (window !== undefined) {
    return window.document.documentElement;
  }
  return false;
};

/**
 * Obtaining the viewport height
 * @method _getViewportH
 * @return ConditionalExpression
 */
const getViewportH = () => {
  const client = getDocElement.clientHeight;
  const inner = window.innerHeight;
  return client < inner ? inner : client;
};

/**
 * The offset of the element
 * @method _getOffset
 * @param {} el
 * @return ObjectExpression
 */
const getOffset = el => {
  let offsetTop = 0;
  let offsetLeft = 0;
  /* eslint-disable */
  do {
    if (!isNaN(el.offsetTop)) {
      offsetTop += el.offsetTop;
    }
    if (!isNaN(el.offsetLeft)) {
      offsetLeft += el.offsetLeft;
    }
  } while ((el = el.offsetParent));
  /* eslint-enable */
  return {
    top: offsetTop,
    left: offsetLeft
  };
};

/**
 * Return true if the element if visible in a viewport zone
 * @param {} el
 * @param {} h
 * @return LogicalExpression
 */
const isElementInViewport = el => {
  if (canIExecuteClientCode() && el) {
    let element = el;
    let top = element.offsetTop;
    let left = element.offsetLeft;
    const width = element.offsetWidth;
    const height = element.offsetHeight;

    while (element.offsetParent) {
      element = element.offsetParent;
      top += element.offsetTop;
      left += element.offsetLeft;
    }

    return (
      top < window.pageYOffset + window.innerHeight &&
      left < window.pageXOffset + window.innerWidth &&
      top + height > window.pageYOffset &&
      left + width > window.pageXOffset
    );
  }
};

/**
 * Returns a promise that resolves once the initial
 * browser processing is done. This allows to save
 * the users that uses low cpu devices and also have
 * awesome results in Google Page Speed
 * @param {*} elementSelector
 * @param {*} inSSR
 */
const canILiftOff = (elementSelector, inSSR = true) => {
  return new Promise(resolve => {
    // we don't need to wait in SSR
    if (window === undefined && inSSR) {
      resolve(true);
    } else {
      // adds global listeners that will trigger
      // once a real person is interacting with the browser
      if (!addedGlobalEventListeners) {
        addGlobalEventListeners();
      }
      // saving all the component instances subscriptions
      subscribersMap[elementSelector] = {
        resolve
      };
    }
  });
};

const canIExecuteClientCode = () => {
  return typeof window !== "undefined";
};

export { canILiftOff, isElementInViewport, canIExecuteClientCode };
